import { render, staticRenderFns } from "./loadcarrierlabel.vue?vue&type=template&id=51089efe&scoped=true&"
import script from "./loadcarrierlabel.vue?vue&type=script&lang=js&"
export * from "./loadcarrierlabel.vue?vue&type=script&lang=js&"
import style0 from "./loadcarrierlabel.vue?vue&type=style&index=0&id=51089efe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51089efe",
  null
  
)

export default component.exports